import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AnalyticsService';
import { EventRepository } from '~repositories/EventRepository';
import { Event } from '~entities/Event';
import { IAccountSidebarBaseData } from '~interfaces/IAnalytics';

export class AccountNonLoyaltyEnrollmentLinkUseCase {
    private eventRepository: EventRepository;
    private accountNonLoyaltyEnrollmentData: IAccountSidebarBaseData;

    constructor(accountNonLoyaltyEnrollmentData: IAccountSidebarBaseData) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.accountNonLoyaltyEnrollmentData = accountNonLoyaltyEnrollmentData;
    }

    public execute() {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: this.accountNonLoyaltyEnrollmentData.eventAction,
            type: 'link',
            payload: this.getAccountNonLoyaltyEnrollmentSignupPayload()
        });
        this.eventRepository.addEventToQueue(newEvent);
    }

    private getAccountNonLoyaltyEnrollmentSignupPayload() {
        const { eventAction, label } = this.accountNonLoyaltyEnrollmentData;

        return {
            event_name: 'my account page',
            event_category: 'my account page',
            event_action: eventAction,
            event_label: label,
            site_type: 'event_based',
            promo_pos: ['account'],
            promo_creative: ['overlay/signup'],
            promo_name: ['account sign up overlay'],
            promo_id: ['account-overlay/signup-account sign up overlay']
        };
    }
}
